import React, { useState, useEffect } from 'react';
import './Navbar.css';
import { WORKS } from './worksData';
import { loadDisplayWorks, getMessages } from './store';

// Au-delà de 99, on affiche "99+"
const capCount = (n) => (n > 99 ? '99+' : n);

// Messages déjà présents dans la conversation de démonstration
const BASE_MESSAGES = 5;

export default function Navbar({ onNavClick, activeModule }) {
  const [workCount, setWorkCount] = useState(WORKS.length);
  const [messageCount, setMessageCount] = useState(BASE_MESSAGES);
  const [menuOpen, setMenuOpen] = useState(false); // menu sandwich (mobile)

  const go = (module) => {
    setMenuOpen(false);
    if (onNavClick) onNavClick(module);
  };

  // Total des travaux (base + ceux ajoutés depuis l'admin)
  // et des messages écrits sur le site
  useEffect(() => {
    // Compte ce qui est réellement affiché (exemples non masqués + admin)
    loadDisplayWorks().then((liste) => setWorkCount(liste.length));
    getMessages().then((list) => {
      // Seuls les messages validés depuis l'admin sont comptés : un message
      // en attente (ou refusé) ne doit pas faire monter le compteur.
      const publies = list.filter((m) => m.status === 'published').length;
      setMessageCount(BASE_MESSAGES + publies);
    });
  }, []);

  return (
    <header className="header">
      <div className="logo" onClick={() => go('home')} style={{ cursor: 'pointer' }}>
        <div>
          <svg className="pill" width="59" height="78" viewBox="0 0 59 78" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.9603 50.618C4.01302 38.977 -2.08086 24.509 0.679386 10.4544C4.47973 -8.88065 28.9219 1.08024 43.7766 20.322C52.7907 31.9897 63.6317 55.1518 56.4844 70.9932C48.857 87.888 22.4147 70.5398 11.0136 50.7247L10.947 50.618H10.9603Z" fill="#0050ff"/>
          </svg>
        </div>
        <span className="logo-text">®</span>
      </div>
      <nav className="nav">
        <a
          href="#work"
          className={activeModule === 'work' ? 'active' : ''}
          onClick={e => { e.preventDefault(); onNavClick && onNavClick('work'); }}
        ><span className="nav-label" data-text="WORK">WORK</span><sup className="work-count">{capCount(workCount)}</sup></a>
        <a
          href="#message"
          className={activeModule === 'message' ? 'active' : ''}
          onClick={e => { e.preventDefault(); onNavClick && onNavClick('message'); }}
        ><span className="nav-label" data-text="MESSAGE">MESSAGE</span><sup className="work-count">{capCount(messageCount)}</sup></a>
        <a
          href="#info"
          className={activeModule === 'info' ? 'active' : ''}
          onClick={e => { e.preventDefault(); onNavClick && onNavClick('info'); }}
        ><span className="nav-label" data-text="CONTACT">CONTACT</span></a>
      </nav>

      {/* Menu mobile : bouton texte "MENU" */}
      <button
        className={`burger${menuOpen ? ' burger--open' : ''}`}
        onClick={() => setMenuOpen((o) => !o)}
        aria-label="Menu"
      >
        {menuOpen ? 'FERMER' : 'MENU'}
      </button>

      {menuOpen && (
        <div className="mobile-menu">
          <a
            href="#work"
            className={activeModule === 'work' ? 'active' : ''}
            style={{ '--i': 0 }}
            onClick={e => { e.preventDefault(); go('work'); }}
          >WORK<sup className="work-count">{capCount(workCount)}</sup></a>
          <a
            href="#message"
            className={activeModule === 'message' ? 'active' : ''}
            style={{ '--i': 1 }}
            onClick={e => { e.preventDefault(); go('message'); }}
          >MESSAGE<sup className="work-count">{capCount(messageCount)}</sup></a>
          <a
            href="#info"
            className={activeModule === 'info' ? 'active' : ''}
            style={{ '--i': 2 }}
            onClick={e => { e.preventDefault(); go('info'); }}
          >CONTACT</a>
        </div>
      )}
    </header>
  );
}